// Main entry — the production View. (No Container: StatusBadge is a pure
// View.) Sim wrappers live under ./sim and are never imported here, so a
// production import of StatusBadge can't pull in fixtures.
export { StatusBadge } from "./StatusBadge";
export type { StatusBadgeProps } from "./StatusBadge";
